
const drink_subredddits_set = new Set(["alchole","beer","homebrewing","beerporn",
"coffee","barista","drunk","fermentation","liquor","scotch","rum","tea","tequila","vodka","whiskey",
"wine","winemaking","cocktails","beerreviews","shots"]);

 export default drink_subredddits_set;